import React, { useMemo } from 'react'
import { date_btoh, ficur } from '../../../helpers/misc'
import moment from 'moment'
const { Box, Text } = require('../../Shared/Base')

const AdChips = React.memo(({ ad }) => {
  const date_shipping_quarter = date_btoh(ad.new_real_estate.availability, 'q')
  const particule = date_shipping_quarter === '1' ? 'er' : 'e'
  const date_shipping = `${date_shipping_quarter}${particule} trim. ${date_btoh(
    ad.new_real_estate.availability,
    'yyyy'
  )}`

  return (
    <Box mt={10} display="flex">
      {ad.new_real_estate &&
        ad.new_real_estate.availability &&
        moment().isBefore(ad.new_real_estate.availability) && (
          <Box bg="#F2C110" px={10} borderRadius={5} mr={10}>
            <Text color="white" lineHeight="1.6">
              {date_shipping}
            </Text>
          </Box>
        )}
      {ad.new_real_estate.tax_advantages.length > 0 &&
        ad.new_real_estate.tax_advantages.split(',').map((ta, i) => (
          <Box px={10} borderRadius={5} border="1px solid " key={i} borderColor="thin">
            <Text lineHeight="1.6">{ta}</Text>
          </Box>
        ))}
    </Box>
  )
})

const NRETitle = ({ ad }) => {
  const tenements = ad.new_real_estate.properties.reduce((acc, e) => [...acc, e], [])
  const ad_rents = tenements.map(x => x.price)
  const ad_rent = [Math.min(...ad_rents), Math.max(...ad_rents)]

  const price_str =
    ad_rent[0] === ad_rent[1]
      ? ficur(ad_rent[0])
      : `de ${ficur(ad_rent[0]).replace(' €', '')} à ${ficur(ad_rent[1])}`

  return (
    <>
      <Box
        display={{ ml: 'flex', xs: 'block' }}
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Box>
          <Box display={{ ml: 'none', xs: 'flex' }} alignItems="center" mb={20}>
            <Box as="span" className="fz-24 " fontWeight="bold">
              {price_str}
            </Box>
          </Box>
          <Box as="h2" fontWeight="bold" fontSize={{ ml: '2.4rem', xs: '1.8rem' }}>
            {ad.new_real_estate.programme_name}
          </Box>
        </Box>
        <Text
          fontSize="24px"
          fontWeight="700"
          ml={20}
          display={{ ml: 'block', xs: 'none' }}
          textAlign="right"
          className="wsn"
        >
          {price_str}
        </Text>
      </Box>
      <Text className="fz-16" color="light">
        {ad.city} {ad.postal_code ? `(${ad.postal_code})` : ''}
      </Text>
      <AdChips ad={ad} />
    </>
  )
}

const ResultTitle = ({ ad }) => {
  const is_premium = ad.source === 'loueragile_premium'
  const price_m2 =
    ad.search_type === 'for_buy' && !ad.new_real_estate ? Math.round(ad.rent / ad.area) : null

  let price_str = ficur(ad.rent)

  const type = useMemo(() => {
    if (ad.type === 'Appartement') return 'Appartement'
    if (ad.type === 'Maison') return 'Maison'
    if (ad.type === 'Immeuble') return 'Immeuble'
    return ad.type
  }, [ad.type])

  if (ad.new_real_estate) return <NRETitle ad={ad} />

  return (
    <Box
      display={{ ml: 'flex', xs: 'block' }}
      justifyContent="space-between"
      alignItems="flex-start"
    >
      <Box>
        <Box display={{ ml: 'none', xs: 'flex' }} alignItems="center" mb={20}>
          <Box as="span" className="fz-24 " fontWeight="bold">
            {price_str}
          </Box>
          {price_m2 && (
            <Box className="fz-16" ml={20} display={{ ml: 'none', xs: 'block' }}>
              {ficur(price_m2)} / m²
            </Box>
          )}
        </Box>
        <Box as="h2" fontWeight="bold" fontSize={{ ml: '2.4rem', xs: '1.8rem' }}>
          {!is_premium && (
            <span>
              {ad.city} ({ad.postal_code}) -{' '}
            </span>
          )}{' '}
          {ad.area} m² - {ad.room} {ad.room > 1 ? 'pièces' : 'pièce'}{' '}
          {ad.bedroom ? `- ${ad.bedroom} ${ad.bedroom > 1 ? 'chambres' : 'chambre'}` : ''}
        </Box>
        {is_premium ? (
          <Text className="fz-16" color="light">
            {ad.type === 'Appartement' ? 'Appartement' : 'Maison'}, {ad.address}
          </Text>
        ) : (
          <Text className="fz-16" color="light">
            {type}, le {date_btoh(ad.sendDate || ad.updated_at || ad.created_at, 'dd MMM à HH:mm')},
            par {ad.owner_type === 'Particulier' ? 'un particulier' : 'une agence'}
          </Text>
        )}
      </Box>
      <Text
        fontSize="3.6rem"
        lineHeight="3.6rem"
        ml={20}
        display={{ ml: 'block', xs: 'none' }}
        textAlign="right"
        className="wsn"
      >
        {price_str}
        {price_m2 && (
          <Box as="span" display="block" className="fz-14">
            {ficur(price_m2)} / m²
          </Box>
        )}
      </Text>
    </Box>
  )
}

export default React.memo(ResultTitle)
